import { ISchema } from "../../domain/mappingTypes";
import { formatDate } from "../../utils/string";
import TextSlicer from "../../ui/TextSlicer/TextSlicer";
import { SAlert, SHeaderSortable, SIcon } from "@avalara/skylab-sdk/react";
import { TPagination } from "./SchemasList";

export type TemplateTableAvalaraProps = {
  templateList: ISchema[];
  onChangeSort: React.Dispatch<React.SetStateAction<TPagination>>;
  onShowConfirm: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    schemaId: string,
    schemaName: string
  ) => void;
  onEdit: (schemaId: string) => void;
};

const TemplateTableAvalara: React.FunctionComponent<TemplateTableAvalaraProps> = (
  props: TemplateTableAvalaraProps
) => {
  const getSortValue = (ascending?: boolean) => {
    if (ascending === true) {
      return "Asc";
    } else if (ascending === false) {
      return "Desc";
    } else {
      return "";
    }
  };

  const formatDateWithAvailability = (date: string) => {
    const formattedDate = formatDate(date);

    if (formattedDate === "Invalid Date") {
      return "Not Available";
    }

    const year = parseInt(formattedDate.split("/")[2]);

    if (year < 2023) {
      return "Not Available";
    }

    return formattedDate;
  };

  const handleSort = (sortData: { id: string; ascending?: boolean }) => {
    props.onChangeSort((previousState) => {
      return {
        ...previousState,
        sort: sortData.id,
        order: getSortValue(sortData.ascending),
      };
    });
  };
  return (
    <table>
      <thead style={{ height: "45px" }}>
        <tr>
          <th style={{ width: "50%" }}>
            <SHeaderSortable
              id="schemaName"
              data-testid="schemaName-header"
              text="Schema name"
              noDefaultSort={true}
              onS-sort={(e) => handleSort(e.detail)}
              onS-unsort={() => handleSort({ id: "", ascending: undefined })}
            ></SHeaderSortable>
          </th>
          <th>
            <SHeaderSortable
              id="schemaInsertedDate"
              data-testid="schema-inserted-date"
              text="Creation date"
              noDefaultSort={true}
              onS-sort={(e) => handleSort(e.detail)}
              onS-unsort={() => handleSort({ id: "", ascending: undefined })}
            ></SHeaderSortable>
          </th>
          <th style={{ width: "15%" }} className="text-center">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {props.templateList?.length === 0 && (
          <tr>
            <td colSpan={10}>
              <div className="no-data-found">
                <i>No data found</i>
              </div>
            </td>
          </tr>
        )}

        {!props.templateList && (
          <tr>
            <td colSpan={10} style={{ paddingTop: "10px" }}>
              <SAlert id="error-alert" status="error" noDismiss>
                <div>An error occurred when trying to get template list.</div>
              </SAlert>
            </td>
          </tr>
        )}

        {props.templateList?.map((item) => {
          const dateToShow = formatDateWithAvailability(item.schemaInsertedDate);
          return (
            <tr key={item.schemaId}>
              <td>
                <TextSlicer value={item.schemaName} />
              </td>
              <td style={{ paddingLeft: "25px" }}>
                {dateToShow === "Not Available" ? (
                  <span style={{ color: "var(--color-gray-light)", fontStyle: "italic" }}>
                    Not Available
                  </span>
                ) : (
                  dateToShow
                )}
              </td>
              <td className="text-center">
                <button
                  disabled={!item.hasSnapshot}
                  className="ghost-blue icon"
                  title={item.hasSnapshot ? "Edit" : "Not editable"}
                  style={{ marginRight: "10px" }}
                  onClick={() => props.onEdit(item.schemaId)}
                >
                  <SIcon name="edit-pencil" />
                </button>
                <button
                  className="ghost-blue icon"
                  title="Delete"
                  style={{ marginLeft: "0" }}
                  onClick={(event) => props.onShowConfirm(event, item.schemaId, item.schemaName)}
                >
                  <SIcon name="trash" />
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TemplateTableAvalara;
